import { Component, Input, OnInit } from '@angular/core';
import { UserModel } from '../../model/user';

@Component({
    selector: 'app-view-user-work-addresses',
    templateUrl: './view-user-work-addresses.component.html',
    styleUrls: ['./view-user-work-addresses.component.scss']
})
export class ViewUserWorkAddressesComponent implements OnInit {
    @Input('user') user: UserModel;
    constructor() {}

    ngOnInit(): void {}
}
